export const PLAY_PARAM_MATCHER = new Set<string>([
    'play',
    'jugar',
    'pelaa',
    'spill',
    'spela',
    'practise'
]);
